/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/logout/app.user.logout.component.ts.
 */
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppUserService} from '../../services/app.user.service';

/**
 * Zweck: Beschreibt class AppUserLogoutComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    template: '',
    standalone: false
})
export class AppUserLogoutComponent implements OnInit, AfterViewInit {
  static id = 'AppUserLogoutComponent';
  model: any = {};

  logout_started = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private route: ActivatedRoute, private router: Router, private authenticationService: AppUserService) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit() {
    // get return url from route parameters or default to '/'
  }

/**
 * Beschreibt Methode ngAfterViewInit und ihren Rückgabevertrag.
 */
  ngAfterViewInit() {
    this.logout();
  }

/**
 * Beschreibt Methode logout und ihren Rückgabevertrag.
 */
  logout() {
    if (!this.logout_started) {
      this.logout_started = true;
      this.authenticationService.logout()
        .subscribe(
          {
            next: (data) => {
              this.authenticationService.isLoggedin$.subscribe(state => {
                this.router.navigate(['/login']);
              });

            },
            error: (e) => {

            }
          });
    }
  }
}
